import "./HelloBar.css";
import React from "react";

const NEW_SITE_URL = "https://rechatai.org";
const SUPPORT_EMAIL = "hello@rechatai.org";
// Pre-filled subject so replies land already triaged as move-related.
const SUPPORT_MAILTO =
  "mailto:" + SUPPORT_EMAIL + "?subject=Help%20moving%20to%20rechatai.org";

// Site-wide relocation notice for the legacy reso.chat domain.
//
// Rendered above the header on every route (including 404, which does not
// render a header of its own) so the move is the first thing a visitor sees
// regardless of which deep link brought them here.
function HelloBar() {
  return (
    <aside className="HelloBar" aria-label="Site relocation notice">
      <div className="HelloBar__inner">
        <div className="HelloBar__text">
          <p className="HelloBar__title">We&rsquo;ve Moved</p>
          <p className="HelloBar__body">
            Reso.chat is now{" "}
            <span className="HelloBar__domain">rechatai.org</span>. We&rsquo;ve
            moved to a new home with a new name, but you can still expect the
            same service and experience you know.
          </p>
          <p className="HelloBar__help">
            Any trouble moving?{" "}
            <a className="HelloBar__mail" href={SUPPORT_MAILTO}>
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>

        {/* Same-tab navigation on purpose: this is a permanent move, not a
            reference link, so the visitor should end up on the new domain
            rather than accumulating a tab behind them. */}
        <a
          className="HelloBar__cta"
          href={NEW_SITE_URL}
          aria-label="Visit rechatai.org and continue where you left off"
        >
          Visit rechatai.org
          <svg
            className="HelloBar__arrow"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
      </div>
    </aside>
  );
}

export default HelloBar;
